import React from 'react';
import { Flex, Box } from './../components/layout/Grid';

const Grid = props => (
  <Flex mx="-10px" my="-10px" flexWrap="wrap">
    {props.iterableItems.map((item, index) => (
      <Box key={index} width={[1, 1, 1 / props.col]} px="10px" my="10px">
        {props.children(item)}
      </Box>
    ))}
  </Flex>
);

export default Grid;
